import api from "../api/axiosInstance";

const API_BASE_URL = "https://api.academyracetiming.com";

const getAuthHeaders = () => ({
    Authorization: `Bearer ${sessionStorage.getItem("adminToken")}`,
});

export const createStudentApi = async (student) => {
    const response = await api.post(
        `${API_BASE_URL}/api/students`,
        student,
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const fetchRaceStudentsApi = async ({
                                               page = 1,
                                               limit = 10,
                                               search,
                                               filter_academy,
                                               status,
                                               gender,
                                               post,
                                               filter_race,
                                               isExport,   // ✅ NEW
                                           } = {}) => {
    const response = await api.get(`${API_BASE_URL}/api/race-students`, {
        params: {
            page,
            limit,
            ...(search         ? { search }         : {}),
            ...(filter_academy ? { filter_academy } : {}),
            ...(status         ? { status }         : {}),
            ...(gender         ? { gender }         : {}),
            ...(post           ? { post }           : {}),
            ...(filter_race    ? { filter_race }    : {}),
            ...(isExport       ? { export: "true" } : {}),
        },
        headers: getAuthHeaders(),
    });
    return response.data;
};

// DELETE single student
export const deleteRaceStudentApi = async (id) => {
    const response = await api.delete(`${API_BASE_URL}/api/students/${id}`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

// DELETE all students
export const deleteAllRaceStudentsApi = async () => {
    const response = await api.delete(`${API_BASE_URL}/api/students`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const fetchAcademiesApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/academies`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const fetchRaceStudentCountsApi = async ({
                                                    search,
                                                    filter_academy,
                                                    gender,
                                                    post,
                                                    filter_race,
                                                } = {}) => {
    const response = await api.get(`${API_BASE_URL}/api/race-students/counts`, {
        params: {
            ...(search         ? { search }         : {}),
            ...(filter_academy ? { filter_academy } : {}),
            ...(gender         ? { gender }         : {}),
            ...(post           ? { post }           : {}),
            ...(filter_race    ? { filter_race }    : {}),
        },
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const fetchActiveRaceApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/races/active`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const activateRaceApi = async ({ gender, post, race }) => {
    const response = await api.post(
        `${API_BASE_URL}/api/races/activate`,
        { gender, post, race },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const deactivateRaceApi = async () => {
    const response = await api.post(
        `${API_BASE_URL}/api/races/deactivate`,
        {},
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const fetchAllRunningSessionsApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/races/session/running`, {
        headers: getAuthHeaders(),
    });
    return response.data; // { runningSessions: [...] }
};

export const startSessionForComboApi = async ({ gender, post, race }) => {
    const response = await api.post(
        `${API_BASE_URL}/api/races/session/start-combo`,
        { gender, post, race },
        { headers: getAuthHeaders() }
    );
    return response.data; // { message, session }
};

export const stopSessionForComboApi = async ({ gender, post, race }) => {
    const response = await api.post(
        `${API_BASE_URL}/api/races/session/stop-combo`,
        { gender, post, race },
        { headers: getAuthHeaders() }
    );
    return response.data; // { message, session }
};

export const fetchSessionHistoryApi = async ({ gender, post, race }) => {
    const response = await api.get(`${API_BASE_URL}/api/races/session/history`, {
        params: { gender, post, race },
        headers: getAuthHeaders(),
    });
    return response.data; // { sessions: [...] }
};

export const bulkUploadStudentsApi = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(`${API_BASE_URL}/api/students/bulk-upload`, formData, {
        headers: {
            ...getAuthHeaders(),
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const fetchAllComboCountsApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/races/students-by-combo/counts-all`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const deleteStudentsByComboApi = async ({ gender, post, race }) => {
    const response = await api.delete(`${API_BASE_URL}/api/races/students-by-combo`, {
        data: { gender, post, race },
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const fetchBasicStudentListApi = async ({
                                                   search,
                                                   gender,
                                                   race,
                                                   post,
                                                   filter_academy,
                                                   page = 1,
                                                   limit = 20,
                                               } = {}) => {
    const response = await api.get(`${API_BASE_URL}/api/students/basic`, {
        params: {
            page,
            limit,
            ...(search         ? { search }         : {}),
            ...(gender         ? { gender }         : {}),
            ...(race           ? { race }           : {}),
            ...(post           ? { post }           : {}),
            ...(filter_academy ? { filter_academy } : {}),
        },
        headers: getAuthHeaders(),
    });
    return response.data;
};

// ── Admin / Customer APIs ────────────────────────────────────────────

export const fetchAdminsApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/admins`, {
        headers: getAuthHeaders(),
    });
    return response.data; // { admins: [...] }
};

export const createAdminApi = async (payload) => {
    const response = await api.post(
        `${API_BASE_URL}/api/admins`,
        payload,
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const deleteAdminApi = async (id) => {
    const response = await api.delete(`${API_BASE_URL}/api/admins/${id}`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const fetchAdminAcademiesApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/admins/academies`, {
        headers: getAuthHeaders(),
    });
    return response.data; // { academies: [...] }
};

export const fetchAdminDashboardApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/dashboard/admin`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const fetchSuperadminDashboardApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/dashboard/superadmin`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

export const adminLoginApi = async (credentials) => {
    const response = await api.post(
        `${API_BASE_URL}/api/admins/login`,
        credentials,
        { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
};

export const adminForgotPasswordApi = async (email) => {
    const response = await api.post(
        `${API_BASE_URL}/api/admins/forgot-password`,
        { email },
        { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
};

export const adminResetPasswordApi = async ({ token, newPassword }) => {
    const response = await api.post(
        `${API_BASE_URL}/api/admins/reset-password`,
        { token, newPassword },
        { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
};

export const fetchAdminSessionsTodayApi = async (adminId) => {
    const url = adminId
        ? `${API_BASE_URL}/api/dashboard/admin-sessions/${adminId}`
        : `${API_BASE_URL}/api/dashboard/admin-sessions`;
    const response = await api.get(url, { headers: getAuthHeaders() });
    return response.data;
};

export const fetchAdminByIdApi = async (adminId) => {
    const url = adminId
        ? `${API_BASE_URL}/api/dashboard/user-details/${adminId}`
        : `${API_BASE_URL}/api/dashboard/user-details`;
    const response = await api.get(url, { headers: getAuthHeaders() });
    return response.data;
};

export const addDeviceApi = async (adminId, { deviceName, deviceIp }) => {
    const response = await api.post(
        `${API_BASE_URL}/api/admins/${adminId}/devices`,
        { deviceName, deviceIp },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const updateDeviceIpApi = async (deviceId, { deviceIp }) => {
    const response = await api.put(
        `${API_BASE_URL}/api/admins/devices/${deviceId}`,
        { deviceIp },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const deleteDeviceApi = async (deviceId) => {
    const response = await api.delete(
        `${API_BASE_URL}/api/admins/devices/${deviceId}`,
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const updateDeviceStatusApi = async (deviceId, status) => {
    const response = await api.patch(
        `${API_BASE_URL}/api/admins/devices/${deviceId}/status`,
        { status },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const resetAdminPasswordApi = async (adminId, newPassword) => {
    const url = adminId
        ? `${API_BASE_URL}/api/dashboard/admin-password/${adminId}`
        : `${API_BASE_URL}/api/dashboard/admin-password`;
    const response = await api.put(
        url,
        { newPassword },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const updateAdminStatusApi = async (adminId, status) => {
    const response = await api.patch(
        `${API_BASE_URL}/api/admins/${adminId}/status`,
        { status },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const deleteAdminRaceLogsApi = async () => {
    const response = await api.delete(
        `${API_BASE_URL}/api/dashboard/admin-race-logs`,
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const fetchAllSessionsTodayApi = async ({
                                                   race,
                                                   gender,
                                                   post,
                                                   admin_id,
                                                   status,
                                               } = {}) => {
    const response = await api.get(
        `${API_BASE_URL}/api/admins/sessions/today`,
        {
            params: {
                ...(race ? { race } : {}),
                ...(gender ? { gender } : {}),
                ...(post ? { post } : {}),
                ...(admin_id ? { admin_id } : {}),
                ...(status ? { status } : {}),
            },
            headers: getAuthHeaders(),
        }
    );
    return response.data;
};

export const fetchMyProfileApi = async () => {
    const response = await api.get(`${API_BASE_URL}/api/dashboard/me`);
    return response.data;
};

export const renewAdminSubscriptionApi = async (adminId) => {
    const response = await api.patch(
        `${API_BASE_URL}/api/admins/${adminId}/renew`
    );
    return response.data;
};